// @flow
import {
  HIDE_REDIRECTING_TO,
  SHOW_REDIRECTING_TO,
  SET_REDIRECTING_TO_COUNT,
  SET_REDIRECTING_TO_PUBLISH_YOUR_CV,
  INCREMENT_REDIRECTING_TO_COUNT,
  LOAD_REDIRECTING_TO_COUNT,
  REDIRECT_REDIRECTING_TO,
} from './actionTypes';

export const hideRedirectingTo = (): TrovitAction => ({
  type: HIDE_REDIRECTING_TO,
});

export const showRedirectingTo = (redirectUrl: string): TrovitAction => ({
  type: SHOW_REDIRECTING_TO,
  payload: redirectUrl,
});

export const setRedirectingToCount = (count: number): TrovitAction => ({
  type: SET_REDIRECTING_TO_COUNT,
  payload: count,
});

export const setRedirectingToPublishYourCv = (isPublishYourCv: boolean): TrovitAction => ({
  type: SET_REDIRECTING_TO_PUBLISH_YOUR_CV,
  payload: isPublishYourCv,
});

export const incrementRedirectingToCount = (): TrovitAction => ({
  type: INCREMENT_REDIRECTING_TO_COUNT,
});

export const loadRedirectingToCount = (): TrovitAction => ({
  type: LOAD_REDIRECTING_TO_COUNT,
});

export const redirectRedirectingTo = (redirectUrl: string): TrovitAction => ({
  type: REDIRECT_REDIRECTING_TO,
  payload: redirectUrl,
});



// WEBPACK FOOTER //
// ./app/Sources/redirectingTo/actions.js